import React from 'react';

// tslint:disable max-line-length
const CChoosePart3Demo: React.FC = () => (
  <>
    <h5>Choosing part 3</h5>
    <p>Now it’s time to finish this off. Beginning: done. Middle: done. You need an ending – the object this person is going to be left standing in front of when your voice is gone.</p>
    <p>Does this person know you so well that they’ve already worked out what’s coming last? Push them a little bit. Right? Something they wouldn’t get for themselves. You’ve got a pretty big building full of stories. It’s not too late to surprise them?</p>
  </>
);

export {
  CChoosePart3Demo,
};
